import { Button, Stack } from '@mui/material';
import { PlusIcon } from '@phosphor-icons/react';
import { type FlowHumanTaskSubtask } from 'flow-schema';

import { HumanTaskStep } from './Step';
import { getDefaultHumanTaskStepConfig } from './utils';
import { useReactFlowViewContext } from '../../../../context/context';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function HumanTaskSteps() {
  const { value: steps = [], setValue } =
    useSelectedNodeField<FlowHumanTaskSubtask['steps']>('config.subtasks.0.steps');
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack gap={4} aria-rowcount={steps.length}>
      {steps.map((step, index) => {
        return (
          <HumanTaskStep
            key={step.id}
            fieldNamePrefix={`config.subtasks.0.steps.${index}`}
            stepIndex={index}
            onDelete={
              steps.length > 1
                ? () => {
                    setValue(steps.filter((value) => value.id !== step.id));
                  }
                : undefined
            }
          />
        );
      })}
      <Button
        variant="contained"
        onClick={() => {
          setValue([...steps, getDefaultHumanTaskStepConfig()]);
        }}
        sx={{ alignSelf: 'flex-start', gap: 1 }}
        disabled={!isEditable}
      >
        <PlusIcon size={12} />
        Add Step
      </Button>
    </Stack>
  );
}
